<template>
  <div data-component-group="form" data-component="user-settings">
    <slot name="beforeForm" />

    <UserSettings
      :items="settings"
      :is-loading="isLoading"
      :is-business-contact="isBusinessContact"
      @change="onChange"
    />
  </div>
</template>

<script>
import UserSettings from '../../lists/Settings';

// TODO: Translate component

export default {
  components: {
    UserSettings,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
    isBusinessContact: {
      type: Boolean,
      default: false,
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    onChange(revert) {
      this.isLoading = true;
      this.onSubmit()
        .catch(() => revert())
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='form'][data-component='user-settings'] {
  padding: $spacing-xl;
  background-color: map.get($colors, shades, 'white');
  border-top: 1px solid map.get($colors, grey, lighten-2);

  > .component-actions {
    padding: 0;
    text-align: right;

    .v-btn {
      margin: 0;

      .v-icon {
        margin: 0 6px 0 0;
      }
    }
  }
}
</style>
